module.exports = __webpack_public_path__ + "static/media/needly.2e2a8e7a.png";